import { connectHook } from 'app/common/components/connect-hook';
import { UsefulSnippits } from './useful-snippits.js';
import { useUsefulSnippits } from './useful-snippits-hook.js';

export default connectHook(UsefulSnippits, useUsefulSnippits);
